import {Injectable} from "@angular/core";
import {environment} from "@env/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable, of, timeout} from "rxjs";
import {catchError} from "rxjs/operators";
import {PaymentBatch} from "../../transactions/transactions.model";
import {GenericService} from "@ui-kit/framework/common/generic.service";

@Injectable({
  providedIn: 'root'
})
export class RunClientPayoutsService extends GenericService<PaymentBatch> {
  constructor(http: HttpClient) {
    super(http, environment.apiTransactHost + '/console/offering/district/accounts/run-client-payouts')
  }

  timeOutSecs = 300; // 5 minutes

  public createPaymentBatch(startDate: string, endDate: string): Observable<any> {
    let body: object | null = { correlationId: null, startDate, endDate };
    return this.callEndpoint(this.getBaseUrl + `/create-batch`, body);
  }

  public submitPaymentBatch(): Observable<any> {
    return this.callEndpoint(this.getBaseUrl + `/submit-batch`, null);
  }

  public getJobInfo(id: string): Observable<any> {
    const requestParams = new HttpParams()
      .set('sort', 'createDate,desc')
      .set('eventTypeCode', id);

    return this.http.get<any>(this.getBaseUrl + `/events`, {params: requestParams})
      .pipe(
        timeout( this.timeOutSecs * 1000),
        catchError(e => {
          console.log(e, 'timeout')
          return of(null)
        }));
  }

  callEndpoint(uri: string, body: object | null) {
    // @ts-ignore
    return this.http.post<any>(uri, body, {responseType: 'text'})
      .pipe(
        timeout( this.timeOutSecs * 1000),
        catchError(e => {
          console.log(e, 'timeout')
          return of(null)
        }));
  }

  get getBaseUrl() {
    return environment.apiTransactHost + '/console/offering/district/accounts/run-client-payouts';
  }
}

